import { render, staticRenderFns } from "./holiday-calendar.vue?vue&type=template&id=2478f70a&"
import script from "./holiday-calendar.vue?vue&type=script&lang=js&"
export * from "./holiday-calendar.vue?vue&type=script&lang=js&"
import style0 from "./holiday-calendar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports